<page-loader *ngIf="isLoaded"></page-loader>
<div class="config-header">
	<h3>Config</h3>
	<div class="config-header-actions">
		<div class="app-c-form-group">
			<select class="app-c-form-control app-c-form-control--sm" [(ngModel)]="selectedLanguage"
				(change)="valueChange()">
				<option *ngFor="let lang of allLang" [value]="lang">{{ lang }}</option>
			</select>
		</div>
		<button class="app-c-btn app-c-btn--primary app-c-btn--curve"
			(click)="createConfig()">Create Config
		</button>
	</div>
</div>
<div class="table-responsive">
	<table class="table config-table">
		<thead>
			<tr>
				<th translate>config.section</th>
				<th translate>config.setting</th>
				<th translate>config.key</th>
				<th translate>config.value</th>
				<th class="actions-col"></th>
			</tr>
			<tr class="filter-row">
				<th>
					<select class="filter-control"
						[(ngModel)]="filters.Section" (change)="valueChange()">
						<option [value]="''">All sections</option>
						<option *ngFor="let section of allSections" [value]="section">
							{{ section }}
						</option>
					</select>
				</th>
				<th>
					<input class="filter-control" type="text" placeholder="Filter..."
						[(ngModel)]="filters.Setting" (input)="searchChange()" />
				</th>
				<th>
					<input class="filter-control" type="text" placeholder="Filter..."
						[(ngModel)]="filters.Key" (input)="searchChange()" />
				</th>
				<th>
					<input class="filter-control" type="text" placeholder="Filter..."
						[(ngModel)]="filters.Value" (input)="searchChange()" />
				</th>
				<th class="actions-col"></th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let config of formattedConfigList">
				<td>{{ config.Section }}</td>
				<td>{{ config.Setting }}</td>
				<td>{{ config.Key }}</td>
				<td>{{ config.Value }}</td>
				<td class="actions-col">
					<button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
						(click)="editConfig(config)" title="Edit">
						<svg-icon icon="edit" class="w-100 h-100"></svg-icon>
					</button>
					<button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20 delete-btn"
						(click)="deleteConfig(config)" title="Delete">
						<svg-icon icon="trash" class="w-100 h-100"></svg-icon>
					</button>
				</td>
			</tr>
		</tbody>
	</table>
	<p *ngIf="formattedConfigList.length === 0" class="empty-state">No config entries found.</p>
</div>
